import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Grid, Button, Typography, Snackbar } from '@mui/material';
import SubscriptionPlansColumn from './subscriptionPlans.column';
import { useNavigate } from 'react-router-dom';
import { getAllSubscription } from './subscriptionPlans.service';
import { Icon } from "@iconify/react";
import './subscriptionPlans.css';
import GenericDataGrid from '../../../components/genericTable';

export default function SubscriptionPlans() {

  const navigate = useNavigate();
  const [subcriptionData, setSubcriptionData] = useState([]);
  const [errors, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [totalDataCount, setTotalDataCount] = useState("");
  const [currenntPagemain, setCurrentPagemain] = useState(0);
  const [rowsperpagemain, setrowsperpagemain] = useState(10);
  const [alert, setAlert] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');

  const alertClose = () => {
    setAlert('');
    setOpenAlert(false);
  };

  useEffect(() => {
    getSubscriptionData(currenntPagemain, rowsperpagemain)
  }, []);

  const getSubscriptionData = async (page = currenntPagemain, limit = rowsperpagemain) => {
    setLoading(true);
    const res = await getAllSubscription(page, limit);
    setLoading(false);
    if (res.statusCode === 200) {
      setSubcriptionData(res.data.subscriptionPlanList);
      setTotalDataCount(res.data.pagination.totalItems);
    } else if (res.statusCode === 400 || res.statusCode === 401 || res.statusCode === 404 || res.statusCode === 500 || res.statusCode === 429) {
      setSubcriptionData([]);
      setError(res.message);
    } else {
      setSubcriptionData([]);
      setError(res.message || 'Something went wrong');
    }
  };

  let subscription = {
    'limit': '',
    'page': '',
    'navigate': navigate,
    'getSubscriptionData': getSubscriptionData,
    'setAlert': setAlert,
    'setOpenAlert': setOpenAlert,
    'setResponseMsg': setResponseMsg,
    'setLoading': setLoading
  }

  const subscriptionnData = SubscriptionPlansColumn(subscription);

  return (
    <>
      <Grid container mb={2} alignItems={'center'}>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3, xl: 3 }}>
          <Typography sx={{ fontSize: '24px', fontWeight: 600 }}>Subscription Plans</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 9, xl: 9 }} textAlign={'end'}>
          <Button variant="contained" className='createBtn' type="submit" onClick={() => { setLoading(true); navigate('/addSubcriptions') }}>
            <span className="btnContent"> <Icon icon="tabler:plus" width="16" height="16" />
              <span>Create Subscription</span>
            </span>
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ width: '100%', padding: '0 0px' }}>
        <GenericDataGrid rows={subcriptionData} columns={subscriptionnData} rowCount={totalDataCount} page={currenntPagemain} pageSize={rowsperpagemain} loading={loading} errors={errors} checkbox='false'
          onPaginationChange={(page, pageSize) => {
            setCurrentPagemain(page);
            setrowsperpagemain(pageSize);
            getSubscriptionData(page, pageSize);
          }}
        />
      </Box>

      <Grid szie={4} textAlign={'end'}>
        {(alert === 'true') && (
          <Snackbar open={openAlert} autoHideDuration={6000} onClose={alertClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                bgcolor: '#B6FFC3',
                py: 1.5,
                px: 4.5,
                borderRadius: '30px',
                boxShadow: 3,
                maxWidth: 400,
                mr: -6
              }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 20C9 20 8.25 19.1667 7.66667 18.5C7.33333 18.1667 7 17.75 6.83333 17.6667C6.58333 17.5833 6 17.5833 5.58333 17.5833C4.66667 17.6667 3.66667 17.6667 3 17C2.33333 16.3333 2.33333 15.25 2.41667 14.4167C2.41667 13.9167 2.5 13.4167 2.33333 13.1667C2.25 12.9167 1.83333 12.5833 1.5 12.3333C0.833333 11.75 0 11 0 10C0 9 0.833333 8.25 1.5 7.66667C1.83333 7.33333 2.25 7 2.33333 6.83333C2.41667 6.58333 2.41667 6 2.41667 5.58333C2.33333 4.66667 2.33333 3.66667 3 3C3.66667 2.33333 4.75 2.33333 5.58333 2.41667C6.08333 2.41667 6.58333 2.5 6.83333 2.33333C7.08333 2.25 7.41667 1.83333 7.66667 1.5C8.25 0.833333 9 0 10 0C11 0 11.75 0.833333 12.3333 1.5C12.6667 1.83333 13 2.25 13.1667 2.33333C13.4167 2.41667 14 2.41667 14.4167 2.41667C15.3333 2.33333 16.3333 2.33333 17 3C17.6667 3.66667 17.6667 4.75 17.5833 5.58333C17.5833 6.08333 17.5 6.58333 17.6667 6.83333C17.75 7.08333 18.1667 7.41667 18.5 7.66667C19.1667 8.25 20 9 20 10C20 11 19.1667 11.75 18.5 12.3333C18.1667 12.6667 17.75 13 17.6667 13.1667C17.5833 13.4167 17.5833 14 17.5833 14.4167C17.6667 15.3333 17.6667 16.3333 17 17C16.3333 17.6667 15.25 17.6667 14.4167 17.5833C13.9167 17.5833 13.4167 17.5 13.1667 17.6667C12.9167 17.75 12.5833 18.1667 12.3333 18.5C11.75 19.1667 11 20 10 20ZM6.25 15.9167C6.66667 15.9167 7.08333 16 7.5 16.0833C8.08333 16.3333 8.58333 16.8333 9 17.3333C9.33333 17.75 9.83333 18.25 10.0833 18.25C10.3333 18.25 10.8333 17.75 11.1667 17.3333C11.5833 16.8333 12.0833 16.3333 12.6667 16.0833C13.25 15.8333 14 15.8333 14.6667 15.9167C15.1667 15.9167 15.8333 16 16 15.8333C16.1667 15.6667 16.0833 15 16.0833 14.5C16 13.8333 16 13.0833 16.25 12.5C16.5 11.9167 17 11.4167 17.5 11C17.8333 10.75 18.3333 10.25 18.3333 10C18.3333 9.75 17.8333 9.25 17.4167 8.91667C16.9167 8.5 16.4167 8 16.1667 7.41667C15.9167 6.83333 15.9167 6.08333 16 5.41667C16 4.91667 16.0833 4.25 15.9167 4.08333C15.75 3.91667 15.0833 4 14.5833 4C13.9167 4.08333 13.1667 4.08333 12.5833 3.83333C12 3.58333 11.5 3.08333 11.0833 2.58333C10.75 2.16667 10.25 1.66667 10 1.66667C9.75 1.66667 9.25 2.16667 8.91667 2.58333C8.5 3.08333 8 3.58333 7.41667 3.83333C6.83333 4.08333 6.08333 4.08333 5.41667 4C4.91667 4 4.25 3.91667 4.08333 4.08333C3.91667 4.25 4 4.91667 4 5.41667C4.08333 6.08333 4.08333 6.83333 3.83333 7.41667C3.58333 8 3.08333 8.5 2.58333 8.91667C2.16667 9.25 1.66667 9.75 1.66667 10C1.66667 10.25 2.16667 10.75 2.58333 11.0833C3.08333 11.5 3.58333 12 3.83333 12.5833C4.08333 13.1667 4.08333 13.9167 4 14.5833C4 15.0833 3.91667 15.75 4.08333 15.9167C4.25 16.0833 4.91667 16 5.41667 16C5.66667 16 5.91667 15.9167 6.25 15.9167ZM9.16667 13.6667L6.08333 10.5833L7.25 9.41667L9.16667 11.3333L13.5833 6.91667L14.75 8.08333L9.16667 13.6667Z" fill="#00AD5E" />
              </svg> &nbsp;&nbsp;
              <Typography
                sx={{ color: '#004d40', fontWeight: 600, fontSize: '0.95rem', flexGrow: 1, }}>
                {responseMsg}
              </Typography>
            </Box>
          </Snackbar>
        )}

        {(alert === 'false') && (
          <Snackbar open={openAlert} autoHideDuration={6000} onClose={alertClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                bgcolor: '#FDEDED',
                py: 1.5,
                px: 4.5,
                borderRadius: '30px',
                boxShadow: 3,
                maxWidth: 400,
                mr: -6
              }}
            >
              <Icon icon="solar:close-circle-linear" width="26" height="26" style={{ color: '#DA342E' }} /> &nbsp;&nbsp;
              <Typography
                sx={{
                  color: '#DA342E',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  flexGrow: 1,
                }}>
                {responseMsg}
              </Typography>
            </Box>
          </Snackbar>
        )}
      </Grid>
    </>
  );
}